import React, { useEffect, useState } from 'react';
import './../../styles/vehicle-management.style.scss';
import { Row, Col, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAmenitiesAction } from '../../actions/admin.action';
import { getBusDetailsAction } from '../../actions/trip-create.actions';
import { getSeatGroupsAction, getSeatTypeAction, getCoachTypeAction, deleteAgentBusAction } from '../../actions/vechicle-actions';
import { tripCreateReducerSelector } from '../../selector/trip-create.selector';
import { BusTable } from '../../components/buses-component/buses-table.component';
import { BusesComponentForm } from '../../components/buses-component/buses-form.component';
import { showConfirm } from '../../components/custom-components/custom-component';
export const BusesPage = () => {

    
    const [formData,setFormData]  =useState([]);
    const [amenities, setAmenities] = useState([]);
    const [seatGroups, setSeatGroups] = useState([]);
    const [seatTypes, setSeatTypes] = useState([]);
    const [coachTypes, setCoachTypes] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getBusDetailsAction());
        fetchAmenitiesAction(setAmenities);
        getSeatGroupsAction(setSeatGroups);
        getSeatTypeAction(setSeatTypes);
        getCoachTypeAction(setCoachTypes)
    }, []);

    const tripCreateReducer = useSelector(tripCreateReducerSelector);
    let { busesData } = tripCreateReducer;

    const onDeleteBus = (record) => {
        if (!record || record.id === null || record.id === undefined) return;

        showConfirm(
            () => {
                deleteAgentBusAction(
                    record.id,
                    () => {
                        message.success("Bus deleted successfully");
                        if (formData && formData.id === record.id) {
                            setFormData([]);
                        }
                        dispatch(getBusDetailsAction());
                    }
                );
            },
            "Delete Bus",
            "Are you sure you want to delete this bus?",
            "Ok"
        );
    };

    return (
        <div className="vehicle-management-root">
            <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
                <Col>
                    <h2>Buses Management</h2>
                </Col>
            </Row>

            <BusTable
                busesData={busesData}
                formData={formData}
                setFormData={setFormData}
                onDelete={onDeleteBus}
            />
            <BusesComponentForm
                formData={formData}
                updateFormData={setFormData}
                busesData={busesData}
                fetchBuses={() => dispatch(getBusDetailsAction())}
                seatGroups={seatGroups.seatGroups}
                seatTypes={seatTypes.seatTypes}
                coachTypes = {coachTypes}
            />

            
        </div>
    );
}; 